// extracted by mini-css-extract-plugin
export default {"form":"ClientEditContainer_form__BQgPf"};